import React from "react";
import "./QuestionImage.css";

const QuestionImage = ({ src, alt, compact = false }) => {
  if (!src) return null;

  return (
    <div className={`question-image ${compact ? "compact" : ""}`}>
      <img src={src} alt={alt || "Question reference"} loading="lazy" />
    </div>
  );
};

export default QuestionImage;
